import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './cookies-ok.css';

export function CookiesMessage() {
  const { t } = useTranslation(['layout']);
  const [isAccepted, setIsAccepted] = useState(true);

  useEffect(() => {
    if (localStorage.getItem('cookies')) {
      setIsAccepted(localStorage.getItem('cookies'));
    } else {
      setIsAccepted(false);
    }
  }, []);

  function allowCookies() {
    localStorage.setItem('cookies', true);
    setIsAccepted(true);
  }

  return (
    <div>
      {!isAccepted && (
        <div className=' cookie fixed bottom-0 w-full'>
          <div className='lg:grid grid-cols-4   gap-8 py-8 md:container md:mx-auto'>
            <div className='text-cookies col-span-3  px-5 py-5 '>
              {t('footer.cookies')}
            </div>
            <div className=' px-5 py-5'>
              <button type='button' onClick={() => allowCookies()} className='button-cookies'>{t('footer.buttonAgree')}</button>
            </div>
          </div>

        </div>
      )}
      {isAccepted && (<div />
      )}
    </div>
  );
}
